import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import { aplusSendPV,aplusGlobalProperty } from "../lib/qtLIb";

const Home = () => import('@/views/Home.vue');
const KB = () => import('@/views/Kb.vue');
const KBSearch = () => import('@/views/kbSearch.vue');
const ImagePage = () => import('@/views/ImagePage.vue');
const VideoPlayer = () => import('@/views/VideoPlayer.vue');
const NotFound = () => import('@/views/404.vue');

Vue.use(VueRouter)
  const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    props: (route: { query: { index: any } }) => {
      return {
        index: route.query.index,
      }
    },
  },
  {
    path: '/kb/:tabIndex/:catalogId',
    name: 'Kb',
    component: KB,
    props: true,
  },
  {
    path: '/kb-search/:tabIndex/:catalogId',
    name: 'kb-search',
    component: KBSearch,
    props: true,
  },
  {
    path: '/imgpg',
    name: 'ImagePage',
    component: ImagePage,
  },
  {
    path: '/imgpg/:articleId',
    name: 'ImagePage1',
    component: ImagePage,
    props:true
  },
  {
    path: '/video/:articleId',
    name: 'VideoPlayer',
    component: VideoPlayer,
    props: true,
  },
  {
    path: '/404',
    name: 'NotFound',
    component: NotFound,
  },
  {
    path: '*',
    component: NotFound,
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to: any, from: any, next: any) => {
  let refererPage = from.name;
  let currentPage = to.name;
  let pageName = "";
  if (to.path === "/") {
    switch (to.fullPath) {
      case "/?index=0":
        currentPage = "星学识";
        pageName = "star_learning_home_page";
        break;
      case "/?index=1":
        currentPage = "星探索";
        pageName = "star_explore_home_page";
        break;
    }
  } else if (to.fullPath.indexOf("/kb/0") > -1) {
    currentPage = "星学识-文章列表";
    pageName = "star_learning_list_page";
  } else if (to.fullPath.indexOf("/kb/1") > -1) {
    currentPage = "星探索-文章列表";
    pageName = "star_explore_list_page";
  }
  if (from.path === "/") {
    switch (from.fullPath) {
      case "/?index=0":
        refererPage = "星学识";
        break;
      case "/?index=1":
        refererPage = "星探索";
        break;
    }
  } else if (from.fullPath.indexOf("/kb/0") > -1) {
    refererPage = "星学识-文章列表";
  } else if (from.fullPath.indexOf("/kb/1") > -1) {
    refererPage = "星探索-文章列表";
  }
  window.console.log(refererPage);
  window.console.log(currentPage);
  const trackData = {
    // eslint-disable-next-line @typescript-eslint/camelcase
    belong_apply: "奔驰铸星培训",
    // eslint-disable-next-line @typescript-eslint/camelcase
    referer_page_name: refererPage,
    // eslint-disable-next-line @typescript-eslint/camelcase
    current_page_name: currentPage,
  };
  aplusGlobalProperty(trackData);

  // 获取当前页面的栏目名称用于上报
  let currentCatalogName = '';
  if (to.params.catalogId && to.fullPath.indexOf("/kb/") > -1) {
    try {
      const store = router.app.$store;
      if (store && store.getters && store.getters.catalogs) {
        const currentTabData = store.getters.catalogs.find((tab: any) => tab.name === 'tab-' + to.params.tabIndex);
        const currentCatalog = currentTabData?.catalogs?.find((c: any) => c.id === Number(to.params.catalogId));
        currentCatalogName = currentCatalog ? currentCatalog.title : '';
      }
    } catch (error) {
      console.error('获取目录信息失败:', error);
    }
  }

  console.log('进入栏目页：', currentCatalogName);

  const pvTrackData = {
    // eslint-disable-next-line @typescript-eslint/camelcase
    page_name: pageName,
    // eslint-disable-next-line @typescript-eslint/camelcase
    search_contents: '',
    // eslint-disable-next-line @typescript-eslint/camelcase
    search_type: '',
    // eslint-disable-next-line @typescript-eslint/camelcase
    current_category: currentCatalogName
    // eslint-disable-next-line @typescript-eslint/camelcase
  };
  aplusSendPV(pvTrackData);
  next();
});


export default router
